export const locale = {
  lang: 'es',
  data: {
    'HEADER': {
      'TITLE': 'Lista de cuentas contables',
      'NEW_CATEGORY': 'Nueva categoria',
    },
  }
};
